/* eslint-disable @fs/zion/logical-over-directional */
import React from 'react'
import { css } from '@emotion/core'

const highlighterStyle = ({ up, left }) => css`
  position: absolute;
  top: ${up};
  left: ${left};
  width: 15%; // Covers the width of a column
  height: 11%; // Covers a couple surnames since the offset/tilt of the images aren't uniform
  background-color: rgba(255, 0, 0, 0.22); // Red and opaque
  pointer-events: none;
`

export default function SurnameHighlight({ row, column }) {
  if (!row || !column) {
    return null
  }
  const leftNum = 12 * (column - 1) + 12
  const left = `${leftNum}%`
  const upNum = 0.9 * (row - 1) + 10
  const up = `${upNum}%`

  return <div data-testid="surname-highlighter" css={highlighterStyle({ up, left })} />
}
